var _path, _path2, _ellipse, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCustomerService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9975 18.8728C34.885 14.7989 30.6294 12.0154 25.7239 12.0154C20.8183 12.0154 16.5627 14.7989 14.4503 18.8728H11.6768C13.9649 13.3696 19.3925 9.5 25.7239 9.5C32.0552 9.5 37.4828 13.3696 39.771 18.8728H36.9975ZM25.841 37.3989C30.6075 37.3558 34.7465 34.6848 36.8794 30.7644H39.6765C37.3505 36.1156 32.0367 39.8677 25.841 39.9144V37.3989Z",
    fill: "#E44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8197 30.7636C37.8437 28.9382 38.4276 26.8327 38.4276 24.5908C38.4276 22.5325 37.9354 20.5892 37.0624 18.8721L42.3158 18.8721C44.2102 18.8721 45.7459 20.4078 45.7459 22.3022V27.3335C45.7459 29.2279 44.2102 30.7636 42.3158 30.7636H36.8197ZM14.7674 30.7636H8.93015C7.03573 30.7636 5.5 29.2279 5.5 27.3335V22.3022C5.5 20.4078 7.03573 18.8721 8.93015 18.8721L14.5247 18.8721C13.6517 20.5892 13.1595 22.5325 13.1595 24.5908C13.1595 26.8327 13.7434 28.9382 14.7674 30.7636Z",
    fill: "#E44336"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.7692,
    cy: 38.7263,
    rx: 2.69787,
    ry: 2.69803,
    fill: "#E44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5498 32.2227L19.9021 31.062L23.8675 29.9014V34.3506H15.5498V32.2227Z",
    fill: "#E44336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7987 34.5439C31.1403 34.5439 35.4705 30.2134 35.4705 24.8715C35.4705 19.5297 31.1403 15.1992 25.7987 15.1992C20.4571 15.1992 16.127 19.5297 16.127 24.8715C16.127 30.2134 20.4571 34.5439 25.7987 34.5439ZM21.345 21.7767C21.0245 21.7767 20.7646 22.0365 20.7646 22.357C20.7646 22.6775 21.0245 22.9374 21.345 22.9374H29.6626C29.9831 22.9374 30.243 22.6775 30.243 22.357C30.243 22.0365 29.9831 21.7767 29.6626 21.7767H21.345ZM20.7646 25.0654C20.7646 24.7449 21.0245 24.485 21.345 24.485H31.4035C31.7241 24.485 31.9839 24.7449 31.9839 25.0654C31.9839 25.3859 31.7241 25.6457 31.4035 25.6457H21.345C21.0245 25.6457 20.7646 25.3859 20.7646 25.0654ZM21.345 27.1933C21.0245 27.1933 20.7647 27.4531 20.7647 27.7736C20.7647 28.0941 21.0245 28.3539 21.345 28.3539H28.5021C28.8226 28.3539 29.0824 28.0941 29.0824 27.7736C29.0824 27.4531 28.8226 27.1933 28.5021 27.1933H21.345Z",
    fill: "#E44336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomerService);
export default __webpack_public_path__ + "static/media/icon-customer-service.09ef7b8a6f99903104d487a9ebedc349.svg";
export { ForwardRef as ReactComponent };